import { render, staticRenderFns } from "./resendActivationLink.vue?vue&type=template&id=69ba4f1f&"
import script from "./resendActivationLink.vue?vue&type=script&lang=js&"
export * from "./resendActivationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports